var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.dropdownList),function(user,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.pick(user)}}},[_c('v-list-item-title',[_vm._v("\n            "+_vm._s(user.name)+"\n        ")])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }